<template>
  <v-radio :value="value" color="primary">
    <template v-slot:label>
      <v-tooltip top color="white" v-if="tooltip && tooltip.length">
        <template v-slot:activator="{on}">
          <span class="grey--text text--darken-3" v-on="on">{{label}}</span>
        </template>
        <div class="grey--text text--darken-3 body-1">{{ tooltip }}</div>
      </v-tooltip>
      <span v-else class="grey--text text--darken-3">{{label}}</span>
    </template>
  </v-radio>
</template>

<script>
export default {
  name: "CustomRadio",
  props: ["value", "label", "tooltip"]
};
</script>
